import { utils } from '../utils.js';
import { historie } from '../history.js';
import { beads } from '../beads.js';
import { modes } from '../modes.js';

export const rectangle = {};

rectangle.start = () => {

    let myPoint = utils.returnPoint(game.input.activePointer.position.x, game.input.activePointer.position.y);
    beads.marquee.hasMoved = false;

    beads.marquee.setX(myPoint.x);
    beads.marquee.setY(myPoint.y);
    beads.marquee.setRotation(- game.cameras.main.rotation);

    modes.start('draw rectangle');
};

rectangle.draw = () => {
    if (game.input.activePointer.isDown) {
        let x = game.input.activePointer.position.x;
        let y = game.input.activePointer.position.y;
        let myPoint = utils.returnPoint(x, y);
        let r = [myPoint.x - beads.marquee.x, myPoint.y - beads.marquee.y];

        if (!beads.marquee.hasMoved) {
            if (r[0] !== 0 || (r[1] !== 0)) {
                beads.marquee.setAlpha(0.3);
                beads.marquee.hasMoved = true;
            }
        }


        let dist = Math.sqrt((r[0] * r[0]) + (r[1] * r[1]));

        let theta = utils.myArcTan(r[0], r[1]);

        let newTheta = theta + beads.marquee.rotation;

        let s = [-(dist * Math.cos(newTheta)), dist * Math.sin(newTheta)];

        beads.marquee.setScale(s[0] / 10, s[1] / 10); // Phaser 3.51

    } else {

        let x = game.input.activePointer.position.x;
        let y = game.input.activePointer.position.y;
        let myPoint = utils.returnPoint(x, y);
        let r = [myPoint.x - beads.marquee.x, myPoint.y - beads.marquee.y];

        let dist = Math.sqrt((r[0] * r[0]) + (r[1] * r[1]));

        let theta = utils.myArcTan(r[0], r[1]);

        let newTheta = theta + beads.marquee.rotation;

        let s = [-(dist * Math.cos(newTheta)), dist * Math.sin(newTheta)];

        beads.marquee.setScale(s[0] / 10, s[1] / 10); // Phaser 3.51


        let mid = [(beads.marquee.x + myPoint.x)/2, (beads.marquee.y + myPoint.y)/2]

        let ta = beads.marquee.rotation - (Math.PI/2);

        beads.arr.forEach(bead => {
            if (bead.ignore) return;
            if (bead.hidden) return;
            let myTest = false;

            let xd = bead.x-mid[0]
            let yd = bead.y-mid[1]
            let bigAngle = utils.myArcTan(xd, yd)
            let smallAngle = bigAngle+ta
            let bdist = Math.sqrt((xd * xd) + (yd * yd))
            let _x = Math.abs(bdist * Math.cos(smallAngle))
            let _y = Math.abs(bdist * Math.sin(smallAngle))

            if (
                _x < Math.abs(s[1]/2)
                && _y < Math.abs(s[0]/2)
            ) {
                myTest = true;
            }

            if (myTest) {
                beads.select(bead);
            } else {
                beads.unselect(bead);
            }
        });

        // before

        beads.arr.forEach(bead => {
            if (bead.ignore) return;
            if (bead.hidden) return;
            if (bead.selected) {
                beads.addColor(bead);
                beads.unselect(bead);
            }
        });
        historie.addAction();

        beads.marquee.setAlpha(0);
        modes.start('rectangle');
    }
};